// Constants will be exported from here

/**
 * Zap platform fee — the single source of truth.
 *
 * Charged to the customer (added on top of the subtotal) and retained by Zap as the Stripe
 * application fee on the destination charge. The web + mobile carts compute the fee amount from
 * `ZAP_FEE_RATE`; UI labels render `ZAP_FEE_PERCENT`. To change the fee, change `ZAP_FEE_PERCENT`
 * here and nothing else.
 *
 * ⚠️ Margin note: Zap pays Stripe's processing (~2.9% + $0.30/txn) out of this fee, so setting it
 * below ~3-4% can make small orders net-negative for Zap.
 */
export const ZAP_FEE_PERCENT = 7.5;
export const ZAP_FEE_RATE = ZAP_FEE_PERCENT / 100;
